export default [
    {
        path: 'emissao-senha',
        component: () => import(
            /* webpackChunkName: 'painel-senha-emissao-senha' */
            '@/views/painel-senha/emissao-senha/Index'
        ),
        redirect: 'emissao-senha/create',
        children: [
            {
                name: 'painel-senha-emissao-senha-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'painel-senha-emissao-senha' */
                    '@/views/painel-senha/emissao-senha/Form.vue'
                ),
            },
        ]
    }
]